import { render, staticRenderFns } from "./mensajeRegistroModal.vue?vue&type=template&id=276c60bc&"
import script from "./mensajeRegistroModal.vue?vue&type=script&lang=js&"
export * from "./mensajeRegistroModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports